import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTimelineTasksAssignmentHours } from 'scenes/Timelines/services/getTimelineTasksAssignmentHours.service';

export const loadTimelineTasksAssignmentHours = createAsyncThunk(
  'timelines/loadTimelineTasksAssignmentHours',
  async ({ projectId, timelineId }) => {
    const response = await getTimelineTasksAssignmentHours(
      projectId,
      timelineId
    );
    return response;
  }
);
